export enum SessionCode
{
    OK              = "session_ok"                  ,
    MISSING_VALUE   = "session_missing_value"       ,
    PARSING         = "session_parsing_error"       ,
    GENERIC         = "session_generic_error"       ,
    INVALID_INPUT   = "session_invalid_input_error" ,
}


export function isSessionCode(value: any)
{
    return Object.values(SessionCode).includes(value)
}